import { EAPP_CHANNEL_VALUE, getAppChannelValue } from '@/channels/code';

// TODO: move to building
import signV4Dev from 'mcd-reuqest-sign-v4/dev';
import signV4Douyin from 'mcd-reuqest-sign-v4/douyin';
import signV4Unionpay from 'mcd-reuqest-sign-v4/unionpay';

// const getMcdSignControllerConfigDomain = () => {
//   switch (process.env.APP_DEPLOY_ENV) {
//     case 'prod':
//       return 'https://cdn.mcd.cn';
//     case 'uat':
//       return 'https://cdn-uat.mcdchina.net';
//     case 'sit':
//       return 'https://cdn-sit.mcdchina.net';
//     case 'dev':
//       return 'https://cdn-dev.mcdchina.net';
//     default:
//       return 'https://cdn.mcd.cn';
//   }
// };

// export const getMcdSignControllerConfigUrl = () => {
//   return `${getMcdSignControllerConfigDomain()}/app/main/assets/apiRatioConfig.json`;
// };

// const canIUseLocalStorage = typeof window !== 'undefined' && !!window.localStorage;
// const canIUseSessionStorage = typeof window !== 'undefined' && !!window.sessionStorage;
// export const MCD_API_SIGN_V4_KEY = 'MCD_API_SIGN_V4_KEY';
// export const MCD_API_SIGN_V4_CONTROLLER_KEY = 'MCD_API_SIGN_V4_CONTROLLER_KEY';

// export const getSignControlVal = () => {
//   if (canIUseLocalStorage) {
//     const val = localStorage.getItem(MCD_API_SIGN_V4_KEY);
//     if (val && !Number.isNaN(Number(val))) {
//       return Number(val);
//     }
//   }
//   const key = Math.floor(Math.random() * 10000);
//   if (canIUseLocalStorage) {
//     localStorage.setItem(MCD_API_SIGN_V4_KEY, String(key));
//   }
//   return key;
// };

// export type SignControlItemType = Record<
//   string,
//   {
//     v4: number;
//   }
// >;

// const getSignControlV4Val = async () => {
//   const _code = getAppChannelValue();
//   const _map: Partial<Record<EAPP_CHANNEL_VALUE, string>> = {
//     [EAPP_CHANNEL_VALUE.DOUYIN]: '38',
//     [EAPP_CHANNEL_VALUE.UNIONPAY]: '37',
//   };
//   const _ct = _map[_code];
//   if (!_ct) return undefined;

//   if (canIUseSessionStorage) {
//     const val = sessionStorage.getItem(MCD_API_SIGN_V4_CONTROLLER_KEY);
//     if (val) {
//       const obj = parseObj(val) as SignControlItemType;
//       if (obj?.[_ct]) {
//         return obj[_ct].v4;
//       }
//       if (obj) {
//         return undefined;
//       }
//     }
//   }

//   try {
//     const res = await axios.get(getMcdSignControllerConfigUrl());
//     // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
//     const data = res.data?.data as SignControlItemType;

//     if (data) {
//       if (canIUseSessionStorage) {
//         sessionStorage.setItem(MCD_API_SIGN_V4_CONTROLLER_KEY, JSON.stringify(data));
//       }
//       const _val = data[_ct]?.v4;
//       if (_val != null) return _val;
//     }
//   } catch (error) {
//     // ignore
//   }

//   return undefined;
// };

// export const getSignControlV4Flag = async (): Promise<boolean> => {
//   const _val = await getSignControlV4Val();
//   if (_val != null) {
//     const _key = getSignControlVal();
//     return _val * 10000 > _key;
//   }
//   return false;
// };

export const getSignV4Func = (requestUrl?: string) => {
  const getChannelSigner = () => {
    const _code = getAppChannelValue();
    if (_code === EAPP_CHANNEL_VALUE.DOUYIN) {
      return signV4Douyin;
    }
    return signV4Unionpay;
  };

  /**
   * 关键：AK/SK 是按环境下发的，签名和目标域名不匹配时网关会直接返回
   *   401 {"message":"client request can't be validated"}
   * 这个响应没有业务 code，前端既不会跳登录也拿不到数据，表现为
   * 「已登录但积分/优惠券/订单全是空」。
   *
   * 而 API 域名可以在运行时被 Cookie CONFIG_API_DOMAIN 覆盖（ChangeEnv 页面），
   * 所以只能按「实际请求域名」选密钥，不能只看构建时的 APP_DEPLOY_ENV。
   *
   * 实测（2026-10）：
   *   api.mcd.cn             → 只认 douyin / unionpay 的 AK
   *   api-{dev,sit,uat}.mcdchina.net → 只认 dev 的 AK
   */
  const host = (() => {
    if (!requestUrl) return '';
    try {
      return new URL(requestUrl, typeof location !== 'undefined' ? location.href : undefined).hostname;
    } catch (error) {
      return '';
    }
  })();

  if (host === 'api.mcd.cn') return getChannelSigner();
  if (host && host.endsWith('mcdchina.net')) return signV4Dev;

  const _env = process.env.APP_DEPLOY_ENV;
  if (_env === 'dev' || _env === 'sit' || _env === 'uat') {
    return signV4Dev;
  }
  return getChannelSigner();
};
